var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTimesheetWeek = function SvgTimesheetWeek(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0698 2.40004V1.59961H12.2702V2.40004H9.07023V1.59961H8.27066V2.40004H5.07066V1.59961H4.27109V2.40004C3.74081 2.40049 3.23235 2.61122 2.85722 2.98603C2.48209 3.36083 2.27092 3.86911 2.27002 4.39939V12.3994C2.2707 12.9297 2.48165 13.438 2.85662 13.813C3.23158 14.188 3.73995 14.3989 4.27023 14.3996H13.0698C13.6001 14.3989 14.1085 14.188 14.4834 13.813C14.8584 13.438 15.0693 12.9297 15.07 12.3994V4.39939C15.0691 3.86926 14.8581 3.36111 14.4831 2.98633C14.1082 2.61155 13.5999 2.40071 13.0698 2.40004ZM14.2696 12.4003C14.2691 12.7183 14.1426 13.0232 13.9177 13.2481C13.6928 13.473 13.3879 13.5996 13.0698 13.6H4.27023C3.95217 13.5996 3.64726 13.473 3.42235 13.2481C3.19745 13.0232 3.0709 12.7183 3.07045 12.4003V4.39939C3.0709 4.08133 3.19745 3.77642 3.42235 3.55152C3.64726 3.32661 3.95217 3.20006 4.27023 3.19961V4.00004H5.07066V3.20046H8.27066V4.00089H9.07109V3.20132H12.2711V4.00174H13.0715V3.20217C13.3896 3.20262 13.6945 3.32917 13.9194 3.55408C14.1443 3.77898 14.2709 4.08389 14.2713 4.40196L14.2696 12.4003Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06962 6.60018C5.40093 6.60018 5.66951 6.3316 5.66951 6.00028C5.66951 5.66897 5.40093 5.40039 5.06962 5.40039C4.73831 5.40039 4.46973 5.66897 4.46973 6.00028C4.46973 6.3316 4.73831 6.60018 5.06962 6.60018Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47001 6.60018C7.80132 6.60018 8.06991 6.3316 8.06991 6.00028C8.06991 5.66897 7.80132 5.40039 7.47001 5.40039C7.1387 5.40039 6.87012 5.66897 6.87012 6.00028C6.87012 6.3316 7.1387 6.60018 7.47001 6.60018Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86991 6.60018C10.2012 6.60018 10.4698 6.3316 10.4698 6.00028C10.4698 5.66897 10.2012 5.40039 9.86991 5.40039C9.5386 5.40039 9.27002 5.66897 9.27002 6.00028C9.27002 6.3316 9.5386 6.60018 9.86991 6.60018Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2703 6.60018C12.6016 6.60018 12.8702 6.3316 12.8702 6.00028C12.8702 5.66897 12.6016 5.40039 12.2703 5.40039C11.939 5.40039 11.6704 5.66897 11.6704 6.00028C11.6704 6.3316 11.939 6.60018 12.2703 6.60018Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06962 9.00057C5.40093 9.00057 5.66951 8.73199 5.66951 8.40067C5.66951 8.06936 5.40093 7.80078 5.06962 7.80078C4.73831 7.80078 4.46973 8.06936 4.46973 8.40067C4.46973 8.73199 4.73831 9.00057 5.06962 9.00057Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47001 9.00057C7.80132 9.00057 8.06991 8.73199 8.06991 8.40067C8.06991 8.06936 7.80132 7.80078 7.47001 7.80078C7.1387 7.80078 6.87012 8.06936 6.87012 8.40067C6.87012 8.73199 7.1387 9.00057 7.47001 9.00057Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86991 9.00057C10.2012 9.00057 10.4698 8.73199 10.4698 8.40067C10.4698 8.06936 10.2012 7.80078 9.86991 7.80078C9.5386 7.80078 9.27002 8.06936 9.27002 8.40067C9.27002 8.73199 9.5386 9.00057 9.86991 9.00057Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2703 9.00057C12.6016 9.00057 12.8702 8.73199 12.8702 8.40067C12.8702 8.06936 12.6016 7.80078 12.2703 7.80078C11.939 7.80078 11.6704 8.06936 11.6704 8.40067C11.6704 8.73199 11.939 9.00057 12.2703 9.00057Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06962 11.399C5.40093 11.399 5.66951 11.1304 5.66951 10.7991C5.66951 10.4678 5.40093 10.1992 5.06962 10.1992C4.73831 10.1992 4.46973 10.4678 4.46973 10.7991C4.46973 11.1304 4.73831 11.399 5.06962 11.399Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47001 11.399C7.80132 11.399 8.06991 11.1304 8.06991 10.7991C8.06991 10.4678 7.80132 10.1992 7.47001 10.1992C7.1387 10.1992 6.87012 10.4678 6.87012 10.7991C6.87012 11.1304 7.1387 11.399 7.47001 11.399Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86991 11.399C10.2012 11.399 10.4698 11.1304 10.4698 10.7991C10.4698 10.4678 10.2012 10.1992 9.86991 10.1992C9.5386 10.1992 9.27002 10.4678 9.27002 10.7991C9.27002 11.1304 9.5386 11.399 9.86991 11.399Z",
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimesheetWeek, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timesheet-week.20ef0cfc.svg";
export { ForwardRef as ReactComponent };